var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon fill-current",attrs:{"width":"20","height":"20","viewBox":"0 0 12 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.2 0.714844H4.8V5.51484H0V7.91484H4.8V12.7148H7.2V7.91484H12V5.51484H7.2V0.714844Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }